export default __webpack_public_path__ + "static/media/coding.658a904a.png";